import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, Injector } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { Observable, Subscription } from 'rxjs';
import { SPORTS_TYPE, sportsTypesChangeListener } from '~/constant/sports.constant';
import { OddConstant } from '~/constant/odd.constant';
import { uiHelper } from '~/helpers/ui.helper';
import { translationHelper } from '~/helpers/translation.helper';
import { AppComponentBase } from '../../shared/app-component-base';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'headerTop',
    templateUrl: './headerTop.html',
})
export class HeaderTop extends AppComponentBase implements OnInit {
    sportEventCount = 17;
    livebets_sporttype_menu_active = 1;
    livebets_fixturetype_menu_active = 0;
    @Output('sportSelect') sportSelect = new EventEmitter();
    @Input() sportType = '';
    @Input() isScoreBox = false;
    @Input() onlyHeaderFor;

    SPORTS_TYPE = SPORTS_TYPE();

    private subscriptionsToStopOnDestroy: Subscription[] = [];

    //
    //
    //  For league Filter
    //
    //
    tournamentObservable: Observable<any>;
    populartournamentObservable;
    notpopulartournamentObservable: Observable<any>;
    allLeagues = [];
    // todo league data output unconfiguredv

    isLeaguesRecevied = false;

    subssportchanged;

    oddDropDown;
    selectAll = {
        name: this._translate.getT('allLeagues'),
        EnumSportType: 0,
        icon: `category-icons/allL.png`,
    };

    leagueIsActive = false;

    constructor(
        public tournamentsService: TournamentsService,
        private _OddConstant: OddConstant,
        private _uiHelper: uiHelper,
        private _translate: translationHelper,
        private _injector: Injector,
    ) {
        super(_injector);
        this.leagueIsActive = false;
        // console.log('sty', this._OddConstant);
        this.oddDropDown =
            this.sportType != ''
                ? this._OddConstant.ODD_DROPDOWN_BY_SPORT[this.sportType]
                : this._OddConstant.ODD_DROPDOWN_BY_SPORT[this.livebets_sporttype_menu_active.toString()];
    }

    init: boolean;

    ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;

        SetLanguage('', '');

        $('.ui.dropdown').dropdown();

        this.oddDropDown =
            this.sportType != ''
                ? this._OddConstant.ODD_DROPDOWN_BY_SPORT[this.sportType]
                : this._OddConstant.ODD_DROPDOWN_BY_SPORT[this.livebets_sporttype_menu_active.toString()];

        //this.GetTournament();

        this.subscriptionsToStopOnDestroy.push(
            this._uiHelper.typeOfListListener.subscribe(item => {
                this.sportChangeHandler(1);
            }),
        );
    }

    GetTournament() {
        this.subscriptionsToStopOnDestroy.push(
            this.tournamentsService
                .getTournamentObservableListTerminal(this.livebets_sporttype_menu_active, 0)
                .subscribe(x => {
                    this.populartournamentObservable = x
                        .filter(f => f.IsPopularTerminal == true)
                        .map(x => {
                            return {
                                name: x.CategoryName,
                                tournamentSportEventCount: x.TournamentSportEventCount,
                                alt: x.TournamentName,
                                EnumSportType: x.TournamentId,
                                icon: `category-icons/${x.IsoName}.png`,
                                SequenceNumber: x.SequenceNumber,
                                BetradarId: x.BetradarId,
                            };
                        });

                    this.notpopulartournamentObservable = x
                        .filter(f => f.IsPopularTerminal != true)
                        .map(x => {
                            return {
                                name: x.CategoryName,
                                tournamentSportEventCount: x.TournamentSportEventCount,
                                alt: x.TournamentName,
                                EnumSportType: x.TournamentId,
                                icon: `category-icons/${x.IsoName}.png`,
                                SequenceNumber: x.SequenceNumber,
                                BetradarId: x.BetradarId,
                            };
                        });

                    if (!this.isLeaguesRecevied) {
                        this.allLeagues = [];
                        this.allLeagues = this.populartournamentObservable;
                        // this.allLeagues = this.allLeagues.sort((a, b) => a.SequenceNumber - b.SequenceNumber);
                        this.allLeagues.unshift(this.selectAll);
                        // this.isLeaguesRecevied = true;
                    }

                    this.allLeagues = this.populartournamentObservable;
                }),
        );
    }

    sportChangeHandler(e) {
        this.tournamentsService.Livebet_SportId = e;
        this.sportSelect.next(e);

        this._uiHelper.setAllOddType_PRE([
            this._OddConstant.ODD_DROPDOWN_BY_SPORT[e].first[0],
            this._OddConstant.ODD_DROPDOWN_BY_SPORT[e].second[0],
            this._OddConstant.ODD_DROPDOWN_BY_SPORT[e].third[0],
        ]);
        this.allLeagues = [];
        this.livebets_sporttype_menu_active = e;

        // if (e != 1) {
        //     this.allLeagues = [this.selectAll];
        //     //  this.tournamentSelectHandler(0);
        // } else {
        //     this.allLeagues = this.populartournamentObservable;
        //     // this.allLeagues = this.allLeagues.sort((a, b) => a.SequenceNumber - b.SequenceNumber);
        //     // this.allLeagues.unshift(this.selectAll);
        //
        //     //  this.tournamentSelectHandler(0);
        // }

        // todo maybe listener or observable method needed
        this.oddDropDown =
            this.sportType != ''
                ? this._OddConstant.ODD_DROPDOWN_BY_SPORT[e]
                : this._OddConstant.ODD_DROPDOWN_BY_SPORT[e];

        this.GetTournament();
    }
    lastSelectedTournament = 1;
    lastSelectedUniqueTournament = 1;

    tournamentSelectHandler(e, item) {
        // console.log('--tournamentSelectHandler--',e)
        // console.log('--ITEMMMM--',item)
        if (e != undefined && e != null && e != null && e != 0) {
            this.leagueIsActive = true;
        } else if (e == 0) {
            this.leagueIsActive = false;
        }

        //console.log('data iss', e);
        this.lastSelectedTournament = e;
        this.lastSelectedUniqueTournament = item.BetradarId;
        this._uiHelper.setTournamentType(e);

        //this.tournamentsService.getSportFixture("header.top.ts subscriber");
    }

    OpenStandingsModal() {
        // $('#Standings_Modal').modal('show');
        // this._uiHelper.setTournamentType(this.lastSelectedTournament);
        this._uiHelper.setUniqueTournament(this.lastSelectedUniqueTournament);
        $('#Standings_Modal')
            .modal({
                detachable: false,
            })
            .modal('show');
    }

    openDialogStandings(e): void {
        $('#Standings_Modal')
            .modal({
                centered: true,
            })
            .modal('show');
    }

    ngOnDestroy(): void {
        this.tournamentObservable = null;
        this.notpopulartournamentObservable = null;

        if (this.subssportchanged) {
            this.subssportchanged.unsubscribe();
            this.subssportchanged = null;
        }

        for (let subscription of this.subscriptionsToStopOnDestroy) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}
